"use client";

import Image from "next/image";
import {
  FiGithub,
  FiLinkedin,
  FiMail,
  FiPhone,
  FiTwitter,
} from "react-icons/fi";

export function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      href: "https://www.linkedin.com/company/nitminer-technologies-private-limited/",
      icon: FiLinkedin,
      label: "LinkedIn",
    },
    {
      href: "https://twitter.com/nitminer",
      icon: FiTwitter,
      label: "Twitter",
    },
    {
      href: "https://github.com/nitminer",
      icon: FiGithub,
      label: "GitHub",
    },
  ];

  return (
    <footer className="bg-black px-4 pb-6 pt-12 text-white">
      <div className="mx-auto grid max-w-7xl gap-8 md:grid-cols-3">
        <div>
          <h2 className="flex items-center gap-2 text-md font-bold text-white">
            <Image
              src="/images/Logo/logo.png"
              alt="NITMiner Logo"
              width={32}
              height={32}
              className="h-8 w-8 object-contain"
            />
            NITMiner Technologies Pvt. Ltd.
          </h2>
          <p className="mt-4 text-sm text-gray-300">
            Pioneering innovation in Blockchain, AI, and Cloud Solutions.
            Bridging academic research with industrial applications.
          </p>
          <span className="mt-4 inline-block rounded-full bg-purple-500/20 px-3 py-1 text-xs text-purple-400">
            NITW Incubated
          </span>
        </div>

        <div>
          <h3 className="mb-4 text-lg font-semibold">Get In Touch</h3>
          <a
            href="mailto:sanghu@nitw.ac.in"
            className="mb-2 flex w-fit items-center gap-2 text-sm text-gray-300"
          >
            <FiMail className="text-yellow-400" />
            sanghu@nitw.ac.in
          </a>
          <a
            href="tel:+917013306805"
            className="flex w-fit items-center gap-2 text-sm text-gray-300"
          >
            <FiPhone className="text-green-400" />
            +91-7013306805
          </a>
          <p className="mt-4 text-sm text-gray-400">Innovation hub at NIT Warangal</p>
        </div>

        <div>
          <h3 className="mb-4 text-lg font-semibold">Follow Us</h3>
          <p className="mb-4 text-sm text-gray-300">Connect on social media</p>
          <div className="flex gap-4 text-xl">
            {socialLinks.map((social) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="cursor-pointer transition hover:text-purple-400"
                >
                  <Icon />
                </a>
              );
            })}
          </div>
        </div>
      </div>

      <div className="mt-10 border-t border-gray-700 pt-6 text-center text-sm text-gray-400">
        <p>© {currentYear} NITMiner Technologies Pvt Ltd. All rights reserved.</p>
        <div className="mt-3 flex justify-center gap-6">
          <span className="cursor-pointer hover:text-purple-400">Privacy Policy</span>
          <span className="cursor-pointer hover:text-purple-400">Terms</span>
          <span className="cursor-pointer hover:text-purple-400">Contact</span>
        </div>
        <p className="mx-auto mt-7 w-fit rounded-xl border border-gray-700 px-3 py-2">
          Designed with love by NITMiner Team
        </p>
      </div>
    </footer>
  );
}
